import React from 'react'
import useCareerExploration from './CareerExplorationProvider'
import { ResultsHeading } from './ResultsSection'
import { Box, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import useTranslation from '../shared/TranslationProvider'

const TableOfContents = () => {
  const { sections } = useCareerExploration()
  const { t } = useTranslation('Page')
  return (
    <div
      className={`fixed right-0 top-20 z-40 h-screen w-96 overflow-y-auto p-4 3xl:relative 3xl:h-full 3xl:w-full 3xl:translate-x-0 3xl:p-0 `}
    >
      <Box className={`size-fit`} variant="outlined" color="primary">
        <Stack spacing={4}>
          <div className="flex items-start justify-between gap-2">
            <Typography variant="subtitle">{t('quick_guide')}</Typography>
          </div>
          {sections.map((section, idx) => (
            <SectionInfo
              key={`toc-${idx}`}
              section={section}
              scrollRefIdx={idx}
            />
          ))}
        </Stack>
      </Box>
    </div>
  )
}

export default TableOfContents

const SectionInfo = ({ section, scrollRefIdx }) => {
  const {
    careers,
    refMap,
    careerDescription,
    requiredEducation,
    relatedWorkExperience,
    keyResponsibilities,
    showSalaryData,
    hasTraits,
  } = useCareerExploration()
  const career = careers[0]
  const handleClick = () => {
    const scrollRef = refMap[scrollRefIdx]
    const ref = scrollRef.current
    window.scrollTo({
      top: ref.offsetTop,
      left: 0,
      behavior: 'smooth',
    })
  }

  const showSection = () => {
    if (section === 'career_development')
      return !!careerDescription(career)?.length
    if (section === 'video') return !!career.video
    if (section === 'education_and_experience')
      return (
        !!requiredEducation(career)?.length ||
        !!relatedWorkExperience(career)?.length
      )
    if (section === 'responsibilities')
      return !!keyResponsibilities(career)?.length
    if (section === 'salary') return showSalaryData()
    if (section === 'related_occupations') return !!career.related?.length
    if (section === 'job_tasks') return !!career.tasks?.length
    if (section === 'traits') return hasTraits(career)
    if (section === 'skills')
      return !!Object.keys(career.technology_skills)?.length
  }

  return (
    showSection() && (
      <ResultsHeading
        onClick={handleClick}
        section={section}
        isToc={true}
        career={career}
        className={'cursor-pointer'}
      />
    )
  )
}
